export {StaticContext, match, withRouter, RouteProps, RouteComponentProps} from 'react-router'
export {Redirect, Route, Link, Switch} from 'react-router-dom'
export {History, Location, LocationState} from 'history'



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/3rd-party/react-router.ts